import { FC } from 'react'

import AzureLogo from '@/assets/logos/azure.svg?react'
import ServiceIntegrationCard from '@/components/service-integration-card'
import { SSO } from '@/out/single-sign-on'
import { SSOProps } from '@/pages/settings/single-sign-on'
import AzureDetails from '@/pages/settings/single-sign-on/azure/details'
import AzureForm from '@/pages/settings/single-sign-on/azure/form'

type Props = SSOProps<'azure'> & {
  configuration: SSO['azure']
  disabled?: boolean
}

const AzureAD: FC<Props> = ({ configuration, setupTimer, onSetup, removeTimer, onRemove, disabled = false }) => {
  return (
    <ServiceIntegrationCard
      title="Azure"
      description="Set up Azure to be the identity provider for single sign-on."
      icon={<AzureLogo className="w-8 h-8" />}
      iconColor="text-[#0078d4]"
      isConnected={!!configuration}
      disabled={disabled}
      disabledMessage="Disable the current provider to enable this one"
      setupContent={<AzureForm timer={setupTimer} onSetup={config => onSetup('azure', config)} />}
      manageContent={
        configuration ? (
          <AzureDetails configuration={configuration} timer={removeTimer} onRemove={() => onRemove('azure')} />
        ) : undefined
      }
    />
  )
}

export default AzureAD
